import { render, staticRenderFns } from "./PublicationBlock.vue?vue&type=template&id=6f1611d9&scoped=true"
import script from "./PublicationBlock.vue?vue&type=script&lang=js"
export * from "./PublicationBlock.vue?vue&type=script&lang=js"
import style0 from "./PublicationBlock.vue?vue&type=style&index=0&id=6f1611d9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1611d9",
  null
  
)

export default component.exports